import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { TosterService } from '../../services/toster.service';
import { Subject, takeUntil } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-reset-password',
  imports: [CommonModule, ReactiveFormsModule,TranslateModule],
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnDestroy {
   private destroy$ = new Subject<void>();
  resetForm: FormGroup;
  showPassword1: boolean = false;
  showPassword: boolean = false;
  email: any = '';
  otp: any = '';
  constructor(private fb: FormBuilder, private router: Router, private authService: AuthService, private tosterService: TosterService, private route: ActivatedRoute) {
    this.resetForm = this.fb.group(
      {
        password: new FormControl('', [Validators.required]),
        confirmpassword: new FormControl('', [Validators.required]),
      },
      { validator: this.passwordMatchValidator }
    );
    this.route.queryParams.subscribe((params) => {
      this.email = params['email'];
      this.otp = params['otp'];
    });
  }

  // Custom Validator to check if password and confirm password match
passwordMatchValidator(form: FormGroup) {
  const password = form.get('password');
  const confirmPassword = form.get('confirmpassword');

  if (!password || !confirmPassword) return null;

  if (password.value !== confirmPassword.value) {
    confirmPassword.setErrors({ passwordMismatch: true });
    return { passwordMismatch: true };
  } else {
    // Clear the error if they match
    if (confirmPassword.hasError('passwordMismatch')) {
      confirmPassword.setErrors(null);
    }
    return null;
  }
}


  // Helper method to get form controls for easy access
  get f() {
    return this.resetForm.controls;
  }

  // Toggle password visibility for both fields
  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }
  togglePasswordVisibility1() {
    this.showPassword1 = !this.showPassword1;
  }
  // Check if passwords match
  passwordsMatch() {
    return !this.resetForm.hasError('passwordMismatch') && this.resetForm.get('confirmpassword')?.touched;
  }

  // Handle password reset submission
  resetPass() {
    if (this.resetForm.invalid) return;
    const { password, confirmpassword } = this.resetForm.value;
    const payload = { email: this.email, otp: this.otp, new_password: password };
    this.authService.resetPassword(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res: any) => {
        if (res.status === true) {
          this.tosterService.showSuccess(res.message)
          this.router.navigate(['/login']);

        }

      },
      error: (errorResponse: any) => {
        this.tosterService.showError(errorResponse.error.message)
      },
    });
  }

    ngOnDestroy(): void {
  this.destroy$.next();
  this.destroy$.complete();
}
}
